/* Cliente del motor de informe (companion /report). */

export interface ReportIssue {
  excerpt: string;
  problema: string;
  arreglo: string;
  severidad: string;
}
export interface ReportData {
  genero?: string;
  scores?: Record<string, number>;
  ppt?: number;
  bps?: number;
  bps_pilares?: Record<string, number>;
  resumen?: string;
  issues?: ReportIssue[];
}
export interface ReportResult {
  narrative: string;
  data: ReportData | null;
  savedPath: string | null;
  truncated?: boolean;
  totalWords?: number;
  analyzedWords?: number;
}

import { COMPANION, companionError, providerError } from "./companion";

export interface SplitInfo {
  chapters: { title: string; palabras: number }[];
  totalWords: number;
  calls: number;
}

/** Cuántos capítulos (y por tanto cuántas llamadas) costaría el informe global. */
export async function splitPreview(text: string): Promise<SplitInfo> {
  const res = await fetch(`${COMPANION}/split`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text }),
  });
  if (!res.ok) throw new Error(`Troceado ${res.status}`);
  return res.json();
}

/** Informe global por capítulos (map-reduce). Tarda minutos: una llamada por capítulo. */
export async function generateGlobalReport(
  apiKey: string,
  model: string,
  text: string,
  contextFiles: string[],
  saveDir: string,
): Promise<ReportResult & { chapterCount?: number }> {
  const res = await fetch(`${COMPANION}/report-global`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(apiKey ? { "x-or-key": apiKey } : {}) },
    body: JSON.stringify({ text, model, contextFiles, saveDir }),
  });
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(providerError("Informe global", res.status, t));
  }
  return res.json();
}

export async function generateReport(
  apiKey: string,
  model: string,
  text: string,
  contextFiles: string[],
  saveDir: string,
): Promise<ReportResult> {
  let res: Response;
  try {
    res = await fetch(`${COMPANION}/report`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...(apiKey ? { "x-or-key": apiKey } : {}) },
      body: JSON.stringify({ text, model, contextFiles, saveDir }),
    });
  } catch (e: any) {
    throw new Error(companionError(e));
  }
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(providerError("Informe", res.status, t));
  }
  return res.json();
}
